<sb-spinner [size]="spinnerSize" class="mb-2 max-w-full"></sb-spinner>
<div class="max-w-64 text-center">
  <span class="text-base font-light text-grey-500">{{ label || ('Loading' | translate) + '...' }}</span>
</div>
